import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const deleteObesrvationQuestion = async (id: number) => {
	const url = `/observations/admin/questions/${id}/`;

	const response = await cmsClient.delete(url);
	return response.data;
};

const useDeleteObservationQuestion = () => {
	const mutation = useMutation(deleteObesrvationQuestion);

	return mutation;
};

export default useDeleteObservationQuestion;
